import type { ReactNode } from "react";

export type PillVariant = "high" | "medium" | "low";

export interface PillProps {
  variant: PillVariant;
  children: ReactNode;
}

export function Pill({ variant, children }: PillProps): JSX.Element {
  return <span className={`pill pill--${variant}`}>{children}</span>;
}
